import { render, staticRenderFns } from "./SetOpenMarket.vue?vue&type=template&id=7b525afe"
import script from "./SetOpenMarket.vue?vue&type=script&lang=js"
export * from "./SetOpenMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports